<template>
  <v-container class="colab-page">
    <v-card class="main-card">
      <v-card-title class="main-title">
        Colaboradores Externos
      </v-card-title>

      <v-divider class="mb-6" />

      <v-card-text>
        <v-row dense>
          <!-- FORM -->
          <v-col cols="12" md="6">
            <v-card class="form-card">
              <v-card-title class="section-title">
                Configuración
              </v-card-title>

              <v-card-text>
                <v-form>
                  <v-text-field
                    v-model="form.empresa"
                    label="Nombre empresa"
                    placeholder="Alumbra Energia"
                    outlined
                    dense
                    prepend-icon="mdi-rename"
                    @input="onEmpresaInput"
                  />
                  
                  <v-file-input
                    v-model="form.imagen"
                    label="Imagen"
                    accept="image/*"
                    outlined
                    dense
                    prepend-icon="mdi-image"
                    class="file-input-pointer"
                    style="cursor:pointer"
                  />

                  <v-text-field
                    v-model="form.color"
                    label="Color corporativo"
                    placeholder="#RRGGBB"
                    outlined
                    dense
                    maxlength="7"
                    prepend-icon="mdi-palette"
                    @input="onColorInput"
                  />

                  <v-btn
                    color="primary"
                    class="mt-4"
                    block
                    @click="saveColaborador"
                  >
                    Guardar colaborador
                  </v-btn>
                </v-form>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- PREVIEW -->
          <v-col cols="12" md="6">
            <v-card class="preview-card">
              <v-card-title class="section-title">
                Vista previa
              </v-card-title>

              <v-card-text>
                <div class="preview-box">
                  <v-img
                    v-if="previewUrl"
                    :src="previewUrl"
                    max-height="180"
                    contain
                    class="preview-image"
                  />
                  <div v-else class="preview-placeholder">
                    Sin imagen
                  </div>
                </div>

                <div class="color-preview">
                  <div
                    class="color-dot"
                    :style="{ backgroundColor: form.color }"
                  />
                  <span>{{ form.color }}</span>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card class="main-card mt-6">
      <v-card-title class="section-title">
        Lista de colaboradores
        <v-spacer></v-spacer>
        <v-btn small color="primary" @click="fetchColaboradores">
          <v-icon left>mdi-reload</v-icon>
          Recargar
        </v-btn>
      </v-card-title>

      <v-divider />

      <v-card-text>
        <v-simple-table>
          <thead>
            <tr>
              <th>Logo</th>
              <th>Nombre</th>
              <th>Color</th>
              <th class="text-right">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="colab in colaboradores" :key="colab.id">
              <td>
                <v-img
                  v-if="colab.imagen"
                  :src="imageUrl(colab.imagen)"
                  max-height="48"
                  max-width="120"
                  contain
                />
              </td>
              <td>{{ colab.nombre }}</td>
              <td>
                <div class="color-preview">
                  <div class="color-dot" :style="{ backgroundColor: colab.color }" />
                  <span>{{ colab.color }}</span>
                </div>
              </td>
              <td class="text-right">
                <v-btn icon color="error" @click="deleteColaborador(colab.id)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </td>
            </tr>
            <tr v-if="colaboradores.length === 0">
              <td colspan="4" class="text-center">Sin colaboradores</td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>



<script>
export default {
  name: "ColaboradoresExt",
  data() {
    return {
      form: {
        empresa: "",
        imagen: null,
        color: "#",
      },
      previewUrl: "",
      colaboradores: [],
    };
  },

  watch: {
    "form.imagen"(file) {
      if (this.previewUrl) {
        URL.revokeObjectURL(this.previewUrl);
        this.previewUrl = "";
      }
      if (Array.isArray(file)) file = file[0];
      if (file && file.length !== undefined && !(file instanceof File)) {
        file = file[0];
      }
      if (file instanceof File) {
        this.previewUrl = URL.createObjectURL(file);
      }
    },
  },

  methods: {
    imageUrl(filename) {
      const apiUrl = process.env.VUE_APP_API_URL || "";
      const base = apiUrl.replace(/\/api\/v1\/?$/, "");
      return `${base}/colaboradores_externos/${filename}`;
    },
    async fetchColaboradores() {
      try {
        const { data } = await window.axios({
          url: `${process.env.VUE_APP_API_URL}/colaboradores_externos`,
          method: "GET",
        });
        this.colaboradores = data || [];
      } catch (error) {
        console.error("Error cargando colaboradores:", error);
      }
    },
    onEmpresaInput(value) {
      // Limitar a 50 caracteres
      if (value.length > 50) {
        this.form.empresa = value.slice(0, 50);
      }
    },
    onColorInput(value) {
      // Fuerza #
      if (!value.startsWith("#")) {
        value = "#" + value.replace("#", "");
      }

      // Solo HEX
      value = value
        .toUpperCase()
        .replace(/[^#0-9A-F]/g, "")
        .slice(0, 7);

      // No permitir borrar el #
      if (value.length === 0) value = "#";

      this.form.color = value;
    },

    async saveColaborador() {
      const formData = new FormData();
      formData.append("nombre", this.form.empresa || "");
      formData.append("color", this.form.color || "#");
      let imagen = this.form.imagen;
      console.log("Imagen antes de procesar:", imagen);
      if (Array.isArray(imagen)) imagen = imagen[0];
      if (imagen && imagen.length !== undefined && !(imagen instanceof File)) {
        imagen = imagen[0];
      }
      if (imagen instanceof File) {
        formData.append("imagen", imagen);
      }
      console.log("Formulario a enviar:", {
        nombre: this.form.empresa,
        color: this.form.color,
        imagen: imagen,
      });
      
      try {
        const { data } = await window.axios({
          url: `${process.env.VUE_APP_API_URL}/colaboradores_externos`,
          method: "POST",
          data: formData,
          headers: { "Content-Type": "multipart/form-data" },
        });
        console.log("Colaborador externo creado:", data);
        await this.fetchColaboradores();
        this.form.empresa = "";
        this.form.imagen = null;
        this.form.color = "#";
      } catch (error) {
        console.error("Error creando colaborador externo:", error);
      }
    },
    async deleteColaborador(id) {
      try {
        await window.axios({
          url: `${process.env.VUE_APP_API_URL}/colaboradores_externos/${id}`,
          method: "DELETE",
        });
        await this.fetchColaboradores();
      } catch (error) {
        console.error("Error eliminando colaborador:", error);
      }
    },
  },

  mounted() {
    this.fetchColaboradores();
  },

  beforeDestroy() {
    if (this.previewUrl) {
      URL.revokeObjectURL(this.previewUrl);
    }
  },
};

</script>

<style>
.file-input-pointer .v-input__control {
  cursor: pointer !important;
}

.colab-page {
  max-width: 1100px;
}

.main-card {
  border-radius: 16px;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.08);
}

.main-title {
  font-size: 1.4rem;
  font-weight: 600;
}

.section-title {
  font-size: 1rem;
  font-weight: 500;
}

.form-card,
.preview-card {
  border-radius: 12px;
  height: 100%;
}

.preview-box {
  border: 1px dashed #ccc;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 16px;
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgb(133, 133, 133);
}

.preview-image {
  border-radius: 8px;
}

.preview-placeholder {
  color: #999;
}

.color-preview {
  display: flex;
  align-items: center;
  gap: 10px;
}

.color-dot {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  border: 1px solid #ccc;
}

</style>
